export default [
    { value: "admin", label: "Админ" },
    { value: "client", label: "Клиент" },
    { value: "provider", label: "Исполнитель" },
    { value: "courier", label: "Экспедитор" },
    { value: "driver", label: "Водитель" },
]
